import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionStatus } from 'app/constants/Enums';
import { Subscription } from 'app/models/subscription';
import { SubscriptionService } from 'app/services/subscription-service/subscription.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-company-subscription',
  templateUrl: './company-subscription.component.html',
  styleUrls: ['./company-subscription.component.scss']
})
export class CompanySubscriptionComponent implements OnInit, OnDestroy {

  @Input() companyId: string;
  processedSubscriptions: Subscription[] = [];
  private readonly onDestroy$ = new Subject<void>();
  isLoading: boolean;
  
  constructor(private readonly subscriptionService: SubscriptionService) {}

  ngOnInit(): void {
    this.isLoading = true
    this.subscriptionService.subscriptions$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (subscriptions: Subscription[]) => {
          if (subscriptions) {
            this.processedSubscriptions = subscriptions.map(subscription => this.mapSubscription(subscription));
            this.isLoading = false;
          }
        },
        error: (error: any) => {
          console.error('Error fetching subscriptions:', error);
          this.isLoading = false
        }
      });
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  private mapSubscription(subscription: Subscription): Subscription {
    const startDate = new Date(subscription.subscriptionStartDate);
    const endDate = new Date(subscription.subscriptionEndDate);

    const daysLeft = this.calculateDaysLeft(startDate, endDate);
    const status = this.setStatus(daysLeft, startDate);
    const duration = this.calculateDuration(startDate, endDate);

    return {
      ...subscription,
      subscriptionStatus: status,
      daysLeft: daysLeft === 1 ? `${daysLeft} Day` : `${daysLeft} Days`,
      duration: duration
    };
  }
  
  private calculateDaysLeft(startDate: Date, endDate: Date): number {
    const today = new Date();
    if(endDate < today){
      return 0;
    }
    const referenceDate = startDate > today ? startDate : today;
    const timeDiff = endDate.getTime() - referenceDate.getTime();   
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
}

  private calculateDuration(startDate: Date, endDate: Date): string {
    const years = endDate.getFullYear() - startDate.getFullYear();
    return years === 1 ? `${years} Year` : `${years} Years`;
  }

  private setStatus(daysLeft: number, startDate: Date): string {
    const today = new Date();
  
    if (startDate > today) {
      return SubscriptionStatus.Starts.toString();
    }
    
    if (daysLeft == 0) {
      return SubscriptionStatus.Expired.toString();
    }
    
    if (daysLeft > 30) {
      return SubscriptionStatus.Active.toString();
    }
    
    return SubscriptionStatus.ExpiringSoon.toString();
  }
}


